exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tc-container .tc-item {\n  display: -ms-flexbox;\n  display: flex; }\n  .tc-container .tc-item:first-child {\n    padding: 10px 10px 0 !important; }\n  .tc-container .tc-item:not(:first-child) {\n    padding: 10px 10px 10px; }\n  .tc-container .tc-item:last-child {\n    color: #042764;\n    border-top: dotted 1px #042764;\n    background-color: #F6F8F9;\n    border-radius: 0 0 5px 5px; }\n  .tc-container .tc-item div,\n  .tc-container .tc-item div strong {\n    display: inline-block; }\n    .tc-container .tc-item div:nth-child(2),\n    .tc-container .tc-item div strong,\n    .tc-container .tc-item div strong:nth-child(2),\n    .tc-container .tc-item div strong strong {\n      margin-left: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-multi-payment/dialog-multi-payment.component.scss
// module id = 924
// module chunks = 22